import {initialQueryState, KTIcon} from '../../../../../../../_metronic/helpers'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {useState} from 'react'
import {Option} from 'react-multi-select-component'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {downloadServerFile} from '../../core/_requests'
import Swal from 'sweetalert2'
import {useFilterExport} from '../../FilterProvider'
import {ListSearchExpiration} from './ListSearchExpiration'
import {ListSearchStatus} from './ListSearchStatus'
import {ListSearchContract} from './ListSearchContract'
import qs from 'qs'
import {ListSearchClient} from './ListSearchClient'
import {ListSearchContractAt} from './ListSearchContractAt'
import {ListSearchSituationDate} from './ListSearchSituationDate'
import {ListSearchFranchises} from '../../../../../../../components/ListSearchFranchise/ListSearchFranchises'
import useAuthorization from '../../../../../../../hooks/useAuthorization'
import {useAuth} from '../../../../../../../app/modules/auth'

const ListToolbar = () => {
  const {currentUser} = useAuth()

  const {filterExport, setFilterExport} = useFilterExport()

  const {updateState} = useQueryRequest()

  const {isLoading} = useQueryResponse()

  const [searchContract, setSearchContract] = useState<string>('')
  const [searchClientName, setSearchClientName] = useState<string>('')

  const [searchDueDateStart, setSearchDueDateStart] = useState<string>('')
  const [searchDueDateEnd, setSearchDueDateEnd] = useState<string>('')
  const [errorsDueDate, setErrorsDueDate] = useState<string[]>([])

  const [searchContractAtStart, setSearchContractAtStart] = useState<string>('')
  const [searchContractAtEnd, setSearchContractAtEnd] = useState<string>('')
  const [errorsContractAt, setErrorsContractAt] = useState<string[]>([])

  const [searchSituationDateStart, setSearchSituationDateStart] = useState<string>('')
  const [searchSituationDateEnd, setSearchSituationDateEnd] = useState<string>('')
  const [errorsSituationDate, setErrorsSituationDate] = useState<string[]>([])

  const [subscriptionStatusSearch, setSubscriptionStatusSearch] = useState<string>('')

  const [selectsStatus, setSelectsStatus] = useState<Option[]>([])

  const [selectsfranchises, setSelectsfranchises] = useState<Option[]>([])
  const [selectsfranchisesSearch, setSelectsfranchisesSearch] = useState<string>('')

  const isAuthorizedToCreate = useAuthorization('kpi.view')
  if (!isAuthorizedToCreate) return <></>

  const resetData = () => {
    setFilterExport({
      franchises: '',
      contract: '',
      client_name: '',
      dueDateStart: '',
      dueDateEnd: '',
      contractAtStart: '',
      contractAtEnd: '',
      situationDateStart: '',
      situationDateEnd: '',
      createdAtStart: '',
      status: '',
      ...initialQueryState,
    })

    updateState({
      franchises: '',
      contract: '',
      client_name: '',
      dueDateStart: '',
      dueDateEnd: '',
      contractAtStart: '',
      contractAtEnd: '',
      situationDateStart: '',
      situationDateEnd: '',
      createdAtStart: '',
      status: '',
      ...initialQueryState,
    })

    setSelectsfranchises([])
    setSelectsfranchisesSearch('')
    setSearchContract('')
    setSearchClientName('')
    setSearchDueDateStart('')
    setSearchDueDateEnd('')
    setSubscriptionStatusSearch('')
    setSearchContractAtStart('')
    setSearchContractAtEnd('')
    setSearchSituationDateStart('')
    setSearchSituationDateEnd('')
  }

  const filterData = () => {
    setFilterExport({
      franchises: selectsfranchisesSearch ? `${selectsfranchisesSearch}` : '',
      contract: searchContract,
      client_name: searchClientName,
      dueDateStart: searchDueDateStart,
      dueDateEnd: searchDueDateEnd,
      contractAtStart: searchContractAtStart,
      contractAtEnd: searchContractAtEnd,
      situationDateStart: searchSituationDateStart,
      situationDateEnd: searchSituationDateEnd,
      status: subscriptionStatusSearch ? `${subscriptionStatusSearch}` : '',
      ...initialQueryState,
    })

    updateState({
      franchises: selectsfranchisesSearch ? `${selectsfranchisesSearch}` : '',
      contract: searchContract ? `${searchContract}` : '',
      client_name: searchClientName,
      dueDateStart: searchDueDateStart ? `${searchDueDateStart}` : '',
      dueDateEnd: searchDueDateEnd ? `${searchDueDateEnd}` : '',
      contractAtStart: searchContractAtStart ? `${searchContractAtStart}` : '',
      contractAtEnd: searchContractAtEnd ? `${searchContractAtEnd}` : '',
      situationDateStart: searchSituationDateStart ? `${searchSituationDateStart}` : '',
      situationDateEnd: searchSituationDateEnd ? `${searchSituationDateEnd}` : '',
      status: subscriptionStatusSearch ? `${subscriptionStatusSearch}` : '',
      ...initialQueryState,
    })

    const closeButton = document.querySelector<HTMLButtonElement>('#kt_drawer_filter_close')

    if (closeButton) {
      closeButton.click()
    }
  }

  function isNotEmpty(obj: unknown) {
    return obj !== undefined && obj !== null && obj !== ''
  }

  // Função para limpar o objeto, removendo campos vazios, 0 ou chaves específicas
  const cleanedFilterExport = Object.keys(filterExport)
    .filter(
      (key) =>
        filterExport[key] !== '' &&
        filterExport[key] !== 0 &&
        key !== 'page' &&
        key !== 'per_page' &&
        key !== 'total'
    )
    .reduce((obj, key) => {
      obj[key.toLowerCase()] = filterExport[key]
      return obj
    }, {})

  const downloadFile = async () => {
    try {
      const result = await downloadServerFile(
        isNotEmpty(cleanedFilterExport) ? qs.stringify(cleanedFilterExport) : undefined
      )
      if (result && result.message) {
        Swal.fire({
          icon: 'info',
          title: 'Relatório em processamento',
          text: result.message,
          confirmButtonColor: '#d33',
        })
      }
    } catch (error: any) {
      await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error?.response?.data?.message,
        timer: 2000,
      })
    }
  }

  return (
    <>
      <button
        disabled={isLoading}
        type='button'
        className='btn btn-light-danger me-3'
        id='kt_drawer_filter_button'
      >
        <KTIcon iconName='filter' className='fs-2' />
        Filtrar
      </button>
      <div
        id='kt_drawer_filter'
        className='bg-body'
        data-kt-drawer='true'
        data-kt-drawer-name='activities'
        data-kt-drawer-activate='true'
        data-kt-drawer-overlay='true'
        data-kt-drawer-width="{default:'300px', 'lg': '500px'}"
        data-kt-drawer-direction='end'
        data-kt-drawer-toggle='#kt_drawer_filter_button'
        data-kt-drawer-close='#kt_drawer_filter_close'
      >
        <div className='card shadow-none rounded-0'>
          <div className='card-header' id='kt_activities_header'>
            <h3 className='card-title fw-bolder text-dark'>Opções de Filtro</h3>

            <div className='card-toolbar'>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-active-light-danger me-n5'
                id='kt_drawer_filter_close'
              >
                <KTIcon iconName='cross' className='fs-1' />
              </button>
            </div>
          </div>
          <div className='card-body position-relative' id='kt_activities_body'>
            <div className='timeline'>
              <div className='px-7 py-5' data-kt-user-table-filter='form'>
                <div className='row'>
                  <div className='col-12'>
                    <ListSearchFranchises
                      setSelectsFranchisesSearch={setSelectsfranchisesSearch}
                      selectsFranchises={selectsfranchises}
                      setSelectsFranchises={setSelectsfranchises}
                      label='Pesquisar por Unidade:'
                    />
                  </div>
                  <div className='col-12'>
                    <ListSearchContract
                      searchContract={searchContract}
                      setSearchContract={setSearchContract}
                    />
                  </div>
                  <div className='col-12'>
                    <ListSearchClient
                      searchClientName={searchClientName}
                      setSearchClientName={setSearchClientName}
                    />
                  </div>
                  <div className='col-12'>
                    <ListSearchExpiration
                      setSearchDueDateStart={setSearchDueDateStart}
                      searchDueDateStart={searchDueDateStart}
                      setSearchDueDateEnd={setSearchDueDateEnd}
                      searchDueDateEnd={searchDueDateEnd}
                      setErrorsDueDate={setErrorsDueDate}
                      errorsDueDate={errorsDueDate}
                    />
                  </div>

                  <div className='col-12'>
                    <ListSearchContractAt
                      searchContractAtStart={searchContractAtStart}
                      setSearchContractAtStart={setSearchContractAtStart}
                      searchContractAtEnd={searchContractAtEnd}
                      setSearchContractAtEnd={setSearchContractAtEnd}
                      setErrorsContractAt={setErrorsContractAt}
                      errorsContractAt={errorsContractAt}
                    />
                  </div>

                  <div className='col-12'>
                    <ListSearchSituationDate
                      searchSituationDateStart={searchSituationDateStart}
                      setSearchSituationDateStart={setSearchSituationDateStart}
                      searchSituationDateEnd={searchSituationDateEnd}
                      setSearchSituationDateEnd={setSearchSituationDateEnd}
                      setErrorsSituationDate={setErrorsSituationDate}
                      errorsSituationDate={errorsSituationDate}
                    />
                  </div>
                  <div className='col-12'>
                    <ListSearchStatus
                      setSubscriptionStatusSearch={setSubscriptionStatusSearch}
                      selectsStatus={selectsStatus}
                      setSelectsStatus={setSelectsStatus}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='card-footer py-5 text-center' id='kt_activities_footer'>
            <div className='d-flex justify-content-end'>
              <button
                type='button'
                disabled={isLoading}
                onClick={resetData}
                className='btn btn-secondary fw-bold me-2 px-6'
                data-kt-menu-dismiss='true'
                data-kt-user-table-filter='reset'
              >
                Limpar
              </button>
              <button
                disabled={
                  isLoading ||
                  errorsSituationDate?.[0]?.length ||
                  errorsSituationDate?.[1]?.length ||
                  errorsContractAt?.[0]?.length ||
                  errorsContractAt?.[1]?.length ||
                  errorsDueDate?.[0]?.length ||
                  errorsDueDate?.[1]?.length
                    ? true
                    : false
                }
                type='button'
                onClick={filterData}
                className='btn btn-danger fw-bold px-6'
                data-kt-menu-dismiss='true'
                data-kt-user-table-filter='filter'
              >
                Filtrar
              </button>
            </div>
          </div>
        </div>
      </div>
      {currentUser?.permissions.includes('kpi.export') && (
        <button
          disabled={isLoading}
          type='button'
          className='btn btn-light-danger me-3'
          data-kt-menu-trigger='click'
          data-kt-menu-placement='bottom-end'
          onClick={() => void downloadFile()}
        >
          <KTIcon iconName='exit-up' className='fs-2' />
          Export
        </button>
      )}
    </>
  )
}

export {ListToolbar}
